import React, { useEffect, useState } from 'react';
import {
    Container,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TableContainer,
    Paper,
    Button,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import {
    Typography,
    TablePagination,
} from "@mui/material";
import { useHistory } from 'react-router-dom';
import {getInsiderProgramsService} from "../../../services/learning_programs.service";
import LoaderWithBackDrop from "../../../components/LoaderWithBackDrop/LoaderWithBackDrop.comp";

const useStyles = makeStyles((theme) => ({
    container: {
        marginTop: theme.spacing(1),
        width: '100%',
        px: { xs: 0, sm: 2 },
        [theme.breakpoints.between('sm', 'md')]: {
            marginTop: '75px',
        },
    },
    tableRoot: {
        width: '100%',
        tableLayout: 'fixed',
        borderCollapse: 'separate',
        borderSpacing: '0px',
    },
    tableHeaderCell: {
        fontSize: '17px',
        fontWeight: 500,
        textAlign: 'center',
        [theme.breakpoints.down('sm')]: {
            fontSize: '12px',
        },
    },
    tableCell: {
        color: '#ED6628',
        textAlign: 'center',
        fontSize: '17px',
        padding: '16px',
        [theme.breakpoints.down('sm')]: {
            wordBreak:'break-word',
            fontSize: '11px',
            padding: '12px !important',
        },
    },
    buttonCell: {
        textAlign: 'center',
        [theme.breakpoints.down('sm')]: {
            padding: '0 !important',
        },
    },

    title: {
        background: 'linear-gradient(to right, #6A8EC9 10%, #8C74A7 35%, #D44C71 59%, #C91C6E 100%)',
        color: 'transparent',
        backgroundClip: 'text',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        fontWeight: '500 !important',
        textAlign: 'center',
        fontSize: '45px !important',
        [theme.breakpoints.down('sm')]: {
            fontSize: "32px !important",
        },
    },
    viewButton: {
        backgroundColor: "#ff6468",
        color: "#fff",
        fontWeight: 'bold',
        fontSize: '16px',
        borderRadius: '20px',
        boxShadow: 'none',
        padding:'10px 20px',
        textTransform: "none",
        '&:hover': {
            backgroundColor: "#ff6468",
            color: "#fff",
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: '10px',
            padding: '8px 0px',
            borderRadius: '8px',
            width: '100%',
            display: 'block',
            minWidth: 'unset',
        },
    }
}));

const DQProLearnerProgramList = () => {
    const classes = useStyles();
    const history = useHistory();
    const [learnerPrograms, setLearnerPrograms] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        getInsiderProgramsService().then(response => {
            console.log('Learning programs', response?.data?.learning_programs);
            const programs = response?.data?.learning_programs || [];
            programs.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
            setLearnerPrograms(programs);
            setLoading(false);
        }).catch(() => {
            setLearnerPrograms([]);
            setLoading(false);
        });
    }, []);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleViewProgram = (program) => {
        history.push(`/dq_pro/products/program/dashboard/${program.code}`, { program });
    };

    return (
        <Container className={classes.container} maxWidth={false}>
            <Typography variant="h2" className={classes.title} sx={{ mb: 2 }}>
                Your Learning Programs
            </Typography>
            <Typography variant="h5" sx={{ fontSize:{xs:'18px', sm:'1.5rem'},textAlign: 'center',p:{xs:'0 20px', sm:'0 30px', lg:'0 170px'},mx:'auto', mb: 4 }}>
            The following is a list of your created programs.
            </Typography>
            <TableContainer component={Paper} sx={{ backgroundColor: '#fff', width:'100%', maxWidth: '100vw', overflowX: 'auto', }}>
                <Table className={classes.tableRoot} aria-label="assessments table">
                    <TableHead>
                        <TableRow>
                            <TableCell className={classes.tableHeaderCell}>Program ID</TableCell>
                            <TableCell className={classes.tableHeaderCell}>Program Name</TableCell>
                            <TableCell className={classes.tableHeaderCell}># of Questions</TableCell>
                            <TableCell className={classes.tableHeaderCell}>Time (min)</TableCell>
                            <TableCell className={classes.tableHeaderCell}></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {learnerPrograms.length > 0 ? (
                            learnerPrograms
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map((learnerProgram) => (
                                    <TableRow key={learnerProgram.code}>
                                        <TableCell className={classes.tableCell}>{learnerProgram.code}</TableCell>
                                        <TableCell className={classes.tableCell}>{learnerProgram.full_name}</TableCell>
                                        <TableCell className={classes.tableCell}>{learnerProgram.length_questions}</TableCell>
                                        <TableCell className={classes.tableCell}>{learnerProgram.time_to_complete_minutes}</TableCell>
                                        <TableCell className={`${classes.tableCell} ${classes.buttonCell}`}>
                                            <Button
                                                className={classes.viewButton}
                                                onClick={() => handleViewProgram(learnerProgram)}
                                            >
                                                View Program
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                ))
                        ) : (
                            <TableRow>
                                <TableCell colSpan={5} align="center">
                                    No programs found.
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
                <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={learnerPrograms.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </TableContainer>
            <LoaderWithBackDrop loading={loading} />
        </Container>
    );
};

export default DQProLearnerProgramList;
